import { ThemeProvider } from 'next-themes';

import { ChatbotButton } from '@/components/shared/ChatbotButton';
import { ErrorBoundary } from '@/components/providers/ErrorBoundary';
import { THEME_STORAGE_KEY } from '@/components/shared/ThemeToggle';
import { ThemeInitializer } from '@/components/ThemeInitializer';
import { Toaster } from '@/components/ui/sonner';
import { useAuthInit } from '@/hooks/useAuthInit';
import { AppRoutes } from '@/routes/AppRoutes';

function App() {
  useAuthInit();

  return (
    <ThemeInitializer>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem={false}
        disableTransitionOnChange
        storageKey={THEME_STORAGE_KEY}
      >
        <ErrorBoundary>
          <AppRoutes />
        </ErrorBoundary>
        <ChatbotButton />
        <Toaster />
      </ThemeProvider>
    </ThemeInitializer>
  );
}

export default App;
